(ns com.theplantscape.plant-web.pages.plants
  (:require    [reagent.core :as r]
               [reitit.frontend.easy :as rfe]
               [com.theplantscape.plant-web.draw.ui-form
                :refer [ui-form-plant ui-form-settings]]
               [com.theplantscape.plant-web.components.search :refer [ui-plant-search]]
               [com.theplantscape.plant-web.api.plants :refer [fetch-plant]]

               [com.theplantscape.plant-web.components.history :refer [ui-history]]
               [com.theplantscape.plant-web.components.tiles :refer [plant-tile]]
               [com.theplantscape.plant-web.draw.state :refer [app-state site-state]]))

(defn change-page [{:keys [id plant-id revision] :as p}]
  (rfe/push-state :plant {:plant-id id}))

(defn change-plant [{:keys [id revision] :as p}]
  (fetch-plant (or (-> p :plant-id) (-> p :id)) revision
               (fn [plant]
                 (if (= (-> @app-state :plant :plant :xt/id) (:xt/id plant))
                   (swap! app-state assoc-in [:plant :plant] (:plant plant))
                   (swap! app-state assoc :plant plant))
                 #_(reset! store plant))))


(defn ui-page-plant-families []
  (let [families nil]
    (fn [] 
      [:div "test"])))

(defn ui-page-plant  [{:keys [path-params] :as route}]
  (let [current-page (r/cursor site-state [:current-route])
        current-plant (r/cursor app-state [:plant]) #_(r/atom nil)]
    (fn []
      [:div.w-full
       [:div
        [:div (:decription @current-plant)]
        [:div.flex.items-start
         [plant-tile (:plant @current-plant)]
         [ui-history (-> @current-plant :plant :xt/id) (:history @current-plant)]]
        #_(str @current-plant)]])))

(defn ui-page-search-plant  [{:keys [path-params] :as route}]
  (let [current-plant (r/cursor app-state [:plant])]
    [:div.w-full
     ;;[:a {:on-click #(reset! current-plant nil) :href (rfe/href :plant-search)} "Search"]
     [:div
      [ui-plant-search change-page]
      (when (:plant @app-state)
       [ui-page-plant route])
      #_[:div
       [:div (:decription @current-plant)]
       [:div.flex.items-start
        [plant-tile (:plant @current-plant)]
        [ui-history (-> @current-plant :plant :xt/id) (:history @current-plant)]]
       #_(str @current-plant)]]
     #_(if (-> @current-plant empty?))
     #_[:div (str (:plant @app-state))]
     #_(when (:plant @app-state)
       [ui-page-plant route])]))

(defn ui-page-plant-add  [{:keys [path-params] :as route}]
  [:<> [ui-form-plant (:identifier path-params)]])
